import axios from 'axios';
import { envConfig } from '../../../env';


// const gmUrl = 'https://server.cottongame.com/cotton'    //线上链接
const gmUrl = envConfig.formalServer + "/cotton"    //线上链接


export const selProduce = params => axios.post(gmUrl + '/admin/selectProduce', params);                   // 查询商品列表
export const apiProduceInster = params => axios.post(gmUrl + '/insertProduce', params)                   // 新增商品
export const modifyProduce = params => axios.post(gmUrl + '/modifyProduce', params,{       //修改商品信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})
export const delayProduce = params => axios.post(gmUrl + '/delayProduce', params,{       ////定时任务
    headers: {
        'Content-Type': 'application/json'
    }
})
export const selProduceTimingTask = params => axios.post(gmUrl + '/selProduceTimingTask', params)  //查询定时任务
export const selProduceTimingTaskList = params => axios.post(gmUrl + '/selProduceTimingTaskList', params)  //查询定时任务列表
export const cancelTimingTask = params => axios.post(gmUrl + '/cancelTimingTask', params)  //取消定时任务
export const multipleOperationProduce = params => axios.post(gmUrl + '/batchModifyProduct', params);  //批量修改
export const cancelTimingTaskList = params => axios.post(gmUrl + '/cancelTimingTaskList', params)  //批量取消定时任务










